import React from 'react';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <header className="header">
        <nav className="nav">
          <div className="logo">
            <h1>🐕 Paws Dog Walking</h1>
          </div>
          <ul className="nav-links">
            <li><a href="#home">Home</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
      </header>

      <main>
        <section id="home" className="hero">
          <div className="hero-content">
            <h2>Professional Dog Walking Services</h2>
            <p>Caring for your furry friends with love and dedication</p>
            <button className="cta-button">Book a Walk</button>
          </div>
        </section>

        <section id="services" className="services">
          <div className="container">
            <h2>Our Services</h2>
            <div className="services-grid">
              <div className="service-card">
                <h3>🚶 Daily Walks</h3>
                <p>Regular walks to keep your dog healthy and happy</p>
                <span className="price">$25/walk</span>
              </div>
              <div className="service-card">
                <h3>🏃 Extended Walks</h3>
                <p>Longer adventures for high-energy dogs</p>
                <span className="price">$35/walk</span>
              </div>
              <div className="service-card">
                <h3>👥 Group Walks</h3>
                <p>Socialization with other friendly dogs</p>
                <span className="price">$20/walk</span>
              </div>
              <div className="service-card">
                <h3>🏠 Pet Sitting</h3>
                <p>In-home care when you're away</p>
                <span className="price">$50/day</span>
              </div>
            </div>
          </div>
        </section>

        <section id="about" className="about">
          <div className="container">
            <h2>About Us</h2>
            <div className="about-content">
              <p>
                At Paws Dog Walking, we're passionate about providing the best care for your beloved pets. 
                With over 5 years of experience, we understand that every dog is unique and deserves 
                personalized attention and care.
              </p>
              <div className="features">
                <div className="feature">
                  <h4>🛡️ Insured & Bonded</h4>
                  <p>Your peace of mind is our priority</p>
                </div>
                <div className="feature">
                  <h4>📱 Real-time Updates</h4>
                  <p>Photos and updates during every walk</p>
                </div>
                <div className="feature">
                  <h4>⏰ Flexible Scheduling</h4>
                  <p>Available 7 days a week</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="contact" className="contact">
          <div className="container">
            <h2>Get In Touch</h2>
            <div className="contact-content">
              <div className="contact-info">
                <h3>Contact Information</h3>
                <p>📞 Phone: (555) 123-PAWS</p>
                <p>📧 Email: hello@pawsdogwalking.com</p>
                <p>📍 Address: 123 Dog Park Lane, Pet City, PC 12345</p>
                <p>🕒 Hours: Mon-Sun 7AM-7PM</p>
              </div>
              <form className="contact-form">
                <h3>Request a Quote</h3>
                <input type="text" placeholder="Your Name" required />
                <input type="email" placeholder="Your Email" required />
                <input type="tel" placeholder="Phone Number" />
                <input type="text" placeholder="Dog's Name" required />
                <select required>
                  <option value="">Select Service</option>
                  <option value="daily">Daily Walk</option>
                  <option value="extended">Extended Walk</option>
                  <option value="group">Group Walk</option>
                  <option value="sitting">Pet Sitting</option>
                </select>
                <textarea placeholder="Additional Information" rows={4}></textarea>
                <button type="submit">Send Message</button>
              </form>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2024 Paws Dog Walking. All rights reserved.</p>
          <p>Keeping tails wagging since 2019 🐾</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
